export function isClient () {
  return typeof window !== 'undefined' 
}

export function isServer () {
  return typeof global !== 'undefined' && global.process && global.process.versions && global.process.versions.node
}

export function isKdocsHost () {
  return isClient() && typeof location !== 'undefined' && /kdocs\.cn$/.test(location.host)
}